var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cars-bg-ats"},[_c('div',{staticClass:"layout"},[_c('v-container',{staticClass:"cont"},[_c('v-row',{staticClass:"inner-cont",attrs:{"align":"center","justify":"center","no-gutters":""}},[_c('v-card',{staticClass:"pa-5 pt-10 rounded-xl"},[_c('carSearch')],1)],1)],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }